import { render, staticRenderFns } from "./HardcodedDate.vue?vue&type=template&id=5b0e37b4&scoped=true&lang=html"
import script from "./HardcodedDate.vue?vue&type=script&lang=js"
export * from "./HardcodedDate.vue?vue&type=script&lang=js"
import style0 from "./HardcodedDate.vue?vue&type=style&index=0&id=5b0e37b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0e37b4",
  null
  
)

export default component.exports